// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(input) {
  return {
    input: input
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "PropertyMlsStatusNotOnMls",
    "PropertyMlsStatusOnMls",
    "PropertyMlsStatusOnMlsButAllowed"
  ]);
}

function unwrap_response_validatePropertyMlsStatus(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["PropertyMlsStatusValidated"]);
}

let variablesConverter = {"validatePropertyMlsStatusInput":{},"__root":{"input":{"r":"validatePropertyMlsStatusInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus":{"u":"response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus"},"validatePropertyMlsStatus":{"u":"response_validatePropertyMlsStatus"}}};

let wrapResponseConverterMap = {
  response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus: RescriptRelay_Internal.wrapUnion,
  response_validatePropertyMlsStatus: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus":{"u":"response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus"},"validatePropertyMlsStatus":{"u":"response_validatePropertyMlsStatus"}}};

let responseConverterMap = {
  response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus: unwrap_response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus,
  response_validatePropertyMlsStatus: unwrap_response_validatePropertyMlsStatus
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MlsStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "validatePropertyMlsStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "mlsStatus",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v3/*: any*/),
                    "type": "PropertyMlsStatusNotOnMls",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v3/*: any*/),
                    "type": "PropertyMlsStatusOnMls",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v3/*: any*/),
                    "type": "PropertyMlsStatusOnMlsButAllowed",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PropertyMlsStatusValidated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MlsStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "validatePropertyMlsStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "mlsStatus",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "type": "PropertyMlsStatusValidated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "04d86054707469165262d2156b440a83",
    "id": null,
    "metadata": {},
    "name": "MlsStatusQuery",
    "operationKind": "query",
    "text": "query MlsStatusQuery(\n  $input: ValidatePropertyMlsStatusInput!\n) {\n  validatePropertyMlsStatus(input: $input) {\n    __typename\n    ... on PropertyMlsStatusValidated {\n      mlsStatus {\n        __typename\n        ... on PropertyMlsStatusNotOnMls {\n          __typename\n        }\n        ... on PropertyMlsStatusOnMls {\n          __typename\n        }\n        ... on PropertyMlsStatusOnMlsButAllowed {\n          __typename\n        }\n      }\n    }\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus = RescriptRelay_Internal.wrapUnion;

let wrap_response_validatePropertyMlsStatus = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus = unwrap_response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus;
exports.wrap_response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus = wrap_response_validatePropertyMlsStatus_PropertyMlsStatusValidated_mlsStatus;
exports.unwrap_response_validatePropertyMlsStatus = unwrap_response_validatePropertyMlsStatus;
exports.wrap_response_validatePropertyMlsStatus = wrap_response_validatePropertyMlsStatus;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
